export const QUERY__RATINGS = 'ratings';
